var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1663 5.41663H3.83301C3.14967 5.41663 2.58301 4.84996 2.58301 4.16663C2.58301 3.48329 3.14967 2.91663 3.83301 2.91663H37.1663C37.8497 2.91663 38.4163 3.48329 38.4163 4.16663C38.4163 4.84996 37.8497 5.41663 37.1663 5.41663Z",
    fill: "url(#paint0_linear_560_2527)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61621 4.16663V24.1166C6.61621 25.75 7.38288 27.3 8.69954 28.2833L17.3829 34.7833C19.2329 36.1666 21.7829 36.1666 23.6329 34.7833L32.3162 28.2833C33.6329 27.3 34.3995 25.75 34.3995 24.1166V4.16663H6.61621ZM27.1662 22.9166H13.8329C13.1495 22.9166 12.5829 22.35 12.5829 21.6666C12.5829 20.9833 13.1495 20.4166 13.8329 20.4166H27.1662C27.8495 20.4166 28.4162 20.9833 28.4162 21.6666C28.4162 22.35 27.8495 22.9166 27.1662 22.9166ZM27.1662 14.5833H13.8329C13.1495 14.5833 12.5829 14.0166 12.5829 13.3333C12.5829 12.65 13.1495 12.0833 13.8329 12.0833H27.1662C27.8495 12.0833 28.4162 12.65 28.4162 13.3333C28.4162 14.0166 27.8495 14.5833 27.1662 14.5833Z",
    fill: "url(#paint1_linear_560_2527)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_560_2527",
    x1: 2.58301,
    y1: 4.16663,
    x2: 38.4163,
    y2: 4.16663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#585858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_560_2527",
    x1: 6.61621,
    y1: 19.9937,
    x2: 34.3995,
    y2: 19.9937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#585858"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.1326458236678be610290dc10e62d95f.svg";
export { ForwardRef as ReactComponent };